import { useWindowSize } from "@/shared/hooks/useWindowSize";
import Screen from "@/constants/screens";

import HeaderDesktop from "./components/HeaderDesktop";
import HeaderMobile from "./components/HeaderMobile";

const Header = (): JSX.Element => {
  const { width } = useWindowSize();

  return width < Screen.DESKTOP_1280 ? <HeaderMobile /> : <HeaderDesktop />;
};

export default Header;
